<template>
  <b-row>
    <b-col lg="12">
      <b-row align-h="center" class="my-4">
        <h2 class="product__title mb-5">Add / Change Logic contract.</h2>
        <b-col lg="12" class="root">
          <b-row
            ><b-col lg="10"
              ><label class="sr-only" for="inline-form-input-username"
                >Address</label
              >
              <b-input-group prepend="Address" class="mb-2 mr-sm-2 mb-sm-0">
                <b-input
                  id="inline-form-input-username"
                  placeholder="Enter address ..."
                  v-model="address"
                ></b-input> </b-input-group
            ></b-col>

            <b-col lg="2"
              ><b-button
                block
                variant="primary"
                @click="submit"
                :disabled="isProcessing"
                >Submit</b-button
              ></b-col
            >
          </b-row></b-col
        >
      </b-row>
    </b-col>
    <Decode
      :isVisible="isVisible"
      @clicked="child_passphrase"
      @redirect="child_redirect"
    />
  </b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { signAndSendTransaction } from '@/ethereum/send'
import Decode from '@/components/modal/Decode.vue'
import CryptoJS from 'crypto-js'
export default {
  components: {
    Decode
  },
  computed: {
    ...mapState(['contracts'])
  },
  data() {
    return {
      address: '',
      isProcessing: false,
      accounts: sessionStorage.getItem('address'),
      isVisible: false,
      passphrase: ''
    }
  },
  methods: {
    ...mapActions(['init_notification']),
    submit: async function() {
      try {
        const { contracts, passphrase, address } = this

        if (!passphrase) {
          this.isVisible = true
          return
        }

        if (!address) return

        this.isProcessing = !this.isProcessing

        let result = await contracts.Proxy.methods.setLogicContract(
          this.address
        )

        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          this.passphrase
        )

        const acc = decrypted.toString(CryptoJS.enc.Utf8)
        const response = await signAndSendTransaction(result, acc)

        if (response) {
          this.isProcessing = !this.isProcessing
          this.init_notification({
            isVisible: true,
            header: 'Contract Reconfigured',
            body: ` ${response.transactionHash}`
          })
        }
      } catch (error) {
        console.log('Error : ', error)
      }
    },
    child_passphrase: function(value) {
      try {
        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          value
        )

        if (
          decrypted.toString(CryptoJS.enc.Utf8) === '' ||
          decrypted.toString(CryptoJS.enc.Utf8).length === 0
        )
          return alert('Invalid passphrase')

        this.passphrase = value
        this.isVisible = false
      } catch (error) {
        const { message } = error

        if (message === 'ciphertext is null')
          return console.log('Encrypted value is null')
      }
    },
    child_redirect: function(path) {
      this.$router.push(path)
    }
  },
  async mounted() {
    const { contracts, accounts } = this

    let result = await contracts.Proxy.methods
      .getProxy()
      .call({ from: accounts })

    this.address = result
  }
}
</script>

<style>
* {
}
</style>
